import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const ProgressChart = ({ data = [] }) => {
  // data is expected as: [{ name: 'Run #1', score: 72 }, ...] where score = Job Match %
  const best = data?.length > 0 ? Math.max(...data.map(d => d?.score || 0)) : 0;
  const latest = data?.length > 0 ? (data[data.length - 1]?.score || 0) : 0;

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-lg p-3 shadow-medium">
          <p className="text-sm font-medium text-popover-foreground">{`Analysis: ${label}`}</p>
          <p className="text-sm text-primary">{`Job Match: ${payload?.[0]?.value}%`}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 sm:p-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 sm:mb-6 space-y-2 sm:space-y-0">
        <h3 className="text-lg font-semibold text-card-foreground">Job Match Progress</h3>
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <div className="w-3 h-3 bg-primary rounded-full"></div>
          <span>Job Match Trend</span>
        </div>
      </div>

      <div className="h-48 sm:h-56 md:h-64">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis
              dataKey="name"
              stroke="var(--color-muted-foreground)"
              fontSize={12}
            />
            <YAxis
              stroke="var(--color-muted-foreground)"
              fontSize={12}
              domain={[0, 100]}
            />
            <Tooltip content={<CustomTooltip />} />
            <Line
              type="monotone"
              dataKey="score"
              stroke="var(--color-primary)"
              strokeWidth={3}
              dot={{ fill: 'var(--color-primary)', strokeWidth: 2, r: 4 }}
              activeDot={{ r: 6, stroke: 'var(--color-primary)', strokeWidth: 2 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
        <div className="text-center">
          <div className="text-2xl font-bold text-success">
            {best}%
          </div>
          <div className="text-xs text-muted-foreground">Best Job Match</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-primary">
            {latest}%
          </div>
          <div className="text-xs text-muted-foreground">Latest Job Match</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-foreground">
            {data?.length}
          </div>
          <div className="text-xs text-muted-foreground">Total Analyses</div>
        </div>
      </div>
    </div>
  );
};

export default ProgressChart;